module.exports = __webpack_public_path__ + "static/media/clubhousemeadows_1.d60b1df6.webp";